import { Redirect, router } from 'expo-router';
import { useAtom } from 'jotai/index';
import * as React from 'react';
import { useEffect, useRef } from 'react';
import {
    BodyMediumRegular,
    BodySmallRegular,
    Separator,
    YStack,
} from 'smoothie';

import { SelectableRow } from '../../../../../bills/components/common/BillRows';
import { selectedIncomeRuleAtomLegacy } from '../../../../state/PaycheckRoutingAtoms';
import {
    IncomeSplitRuleDescriptions,
    IncomeSplitRuleNames,
    IncomeSplitRuleType,
} from '../../../../types/IncomeSplit';
import IncomeSplitSubscreenWrapper from './IncomeSplitSubscreenWrapper';

const EditType = () => {
    const [selectedRule, setSelectedRule] = useAtom(
        selectedIncomeRuleAtomLegacy,
    );
    const prevType = useRef<string | null>(null);

    useEffect(() => {
        if (prevType.current != null) {
            // new type selected, move back
            router.back();
        } else {
            prevType.current = selectedRule?.type ?? null;
        }
    }, [selectedRule?.type]);

    if (!selectedRule) {
        return <Redirect href="/" />;
    }

    return (
        <IncomeSplitSubscreenWrapper header="Rule type">
            <YStack separator={<Separator />} gap={14}>
                {[
                    IncomeSplitRuleType.MINIMUM_BALANCE,
                    IncomeSplitRuleType.PERCENTAGE,
                ].map((ruleType, i) => {
                    const isSelected = selectedRule.type === ruleType;

                    return (
                        <SelectableRow
                            key={i}
                            isSelected={isSelected}
                            isMultiSelect={false}
                            isFirstRow={i === 0}
                            onSelect={() => {
                                if (isSelected) {
                                    router.back();
                                } else {
                                    setSelectedRule({
                                        ...selectedRule,
                                        type: ruleType,
                                    });
                                }
                            }}
                            rowContentComponent={
                                <YStack padding={2} maxWidth="90%">
                                    <BodyMediumRegular>
                                        {IncomeSplitRuleNames[ruleType]}
                                    </BodyMediumRegular>
                                    <BodySmallRegular color="$gray1000">
                                        {IncomeSplitRuleDescriptions[ruleType]}
                                    </BodySmallRegular>
                                </YStack>
                            }
                        />
                    );
                })}
            </YStack>
        </IncomeSplitSubscreenWrapper>
    );
};

export default EditType;
